import { Grid, TextField, Typography, useMediaQuery, useTheme } from '@mui/material';
import { useState, useEffect, Fragment } from 'react';
import { useDispatch } from 'react-redux';
import Styles from '../../theme/commonCss/Styles';
import { ontologyMasterActions } from '../../store/reducers/ontology-master';
import { addLevelSchema, addLevelUISchema } from './form';
import Ajv from 'ajv';
import AjvErrors from 'ajv-errors';
import FormModal from '../../common/formModal';
import reduce from 'lodash/reduce';
import { get, isEmpty } from 'lodash';
import { useOutletContext } from 'react-router-dom';

const OntologyStyles = {
  labelGrid: {
    ...Styles.gridItem,
    '&.MuiGrid-item': {
      paddingTop: '20px !important',
    },
  },
  inputGrid: {
    '&.MuiGrid-item': {
      padding: '16px 0px 12px 0px',
    },
  },
  input: {
    '&.MuiTextField-root': {
      margin: '0',
    },
  },
};

const AddLevels = ({ isOpen, title, data, levelMaster, setNewLevel, handleClose = () => {} }: any) => {
  const themeData: any = useTheme();
  const dispatch = useDispatch();
  const responsiveSize = useMediaQuery('(max-width:900px)');
  const ajv = new Ajv({ allErrors: true });
  AjvErrors(ajv);
  const validate = ajv.compile(addLevelSchema);
  const { level_name, level_id, parent_id, level_number } = data;
  const [formData, setFormData] = useState<any>({});
  const [ajvErrors, setAjvErrors] = useState<any>({});

  useEffect(() => {
    if (data.isEdit && !isEmpty(data.onto_data)) {
      setFormData(data.onto_data[0]);
    } else {
      setFormData({
        onto_level_id: '',
        onto_manage_title: '',
        parent_id: '',
        onto_manage_id: '',
      });
    }
  }, [data]);

  const handleChange = (e: any) => {
    const { value } = e.target;
    if (data.isEdit) {
      setFormData((prev: any) => {
        return { ...prev, onto_manage_title: value };
      });
    } else {
      let reqData = {
        onto_level_id: level_id,
        onto_manage_title: value,
        parent_id: parent_id,
      };
      setFormData(reqData);
    }
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();
    const trimmedFormData = reduce(
      formData,
      (acc: any, value: any, key: any) => {
        acc[key] = typeof value === 'string' ? value.trim() : value;
        return {
          ...acc,
        };
      },
      {}
    );
    setFormData(trimmedFormData);
    if (validate({ ...trimmedFormData })) {
      if (data.isEdit) {
        dispatch(ontologyMasterActions.updateOntologyMasterReq(trimmedFormData));
      } else {
        dispatch(ontologyMasterActions.addOntologyMasterReq(trimmedFormData));
      }
      dispatch(ontologyMasterActions.setCurrentLevelMaster(levelMaster));
      setNewLevel({ ...trimmedFormData, onto_level_number: level_number });
      setAjvErrors({});
      handleClose();
    } else {
      if (validate.errors) {
        setAjvErrors(validate.errors[0]);
      }
    }
  };

  return (
    <FormModal title={title} isOpen={isOpen} handleSubmit={handleSubmit} handleClose={handleClose}>
      {/* <CardContent> */}
      <Grid container spacing={2}>
        {addLevelUISchema.map(({ label, name }) => (
          <Fragment key={name}>
            <Grid item xs={12} sm={12} md={4}  sx={{...OntologyStyles.labelGrid,justifyContent: responsiveSize ? 'flex-start' : 'flex-end', alignItem:'center'}}>
              <Typography sx={{ ...Styles.inputLabel, color: themeData.palette.text.primary }}>
                {level_name} {label}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={12} md={8} sx={{...OntologyStyles.inputGrid,  '&.MuiGrid-item': {
                    padding: responsiveSize ? '4px 0px 0px 16px' : '12px',
                  },}}>
              <TextField
                sx={OntologyStyles.input}
                margin='normal'
                fullWidth
                id={name}
                onChange={handleChange}
                name={name}
                autoFocus
                variant='outlined'
                size='small'
                value={formData[name]}
                helperText={ajvErrors.instancePath && ajvErrors.instancePath.includes(name) && ajvErrors.message}
                error={ajvErrors.instancePath && ajvErrors.instancePath.includes(name)}
              />
            </Grid>
          </Fragment>
        ))}
      </Grid>
    </FormModal>
  );
};

export default AddLevels;
